import { Box, Divider, MenuItem, MenuList, Typography } from "@mui/material";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth } from "src/auth/AuthContext";
import MenuPopover from "src/shared_components/menu/MenuPopover";

interface AccountPopoverProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  open: boolean;
  username: string | undefined;
}

export const AccountPopover: React.FC<AccountPopoverProps> = (props) => {
  const { anchorEl, onClose, open, username } = props;
  const navigate = useNavigate();
  const auth = useAuth();
  const { t } = useTranslation();

  const handleSignOut = useCallback(() => {
    onClose?.();
    auth.signOut();
    navigate("/login", { replace: true });
  }, [onClose, auth]);

  return (
    <MenuPopover
      anchorEl={anchorEl}
      arrow="top-right"
      onClose={onClose}
      open={open}
    >
      <Box
        sx={{
          py: 1.5,
          px: 2,
        }}
      >
        <Typography variant="overline">{t("common.labels.account", "Account")}</Typography>
        <Typography color="text.secondary" variant="body2">
          {username}
        </Typography>
      </Box>
      <Divider />
      <MenuList
        disablePadding
        dense
        sx={{
          p: "8px",
          "& > *": {
            borderRadius: 1,
          },
        }}
      >
        <MenuItem onClick={handleSignOut}>{t("common.labels.signOut", "Sign out")}</MenuItem>
      </MenuList>
    </MenuPopover>
  );
};
